import { Link as DefaultLink } from '@twistopayments/design-system/components/atoms/link'
import { Typography } from '@twistopayments/design-system/components/atoms/typography'
import { hiddenDown } from '@twistopayments/design-system/styles'

import type { LinkUrl, LinksLinkComponent } from '@twisto/api-cms'

import { getLinkUrl } from 'homepage/utils'

import * as styles from './base-link.styles'

export const BaseLink = ({
  url,
  newTab,
  text,
  color,
  underline,
  hover,
  fontWeight,
  variant,
  inverted = false,
  hideOnMobile,
  hide,
}: LinksLinkComponent & {
  inverted?: boolean
  hideOnMobile?: boolean
  hide?: boolean
}) => (
  <DefaultLink
    css={[(hideOnMobile || hide) && hiddenDown('md')]}
    hover={hover}
    href={url}
    target={newTab === true ? '_blank' : undefined}
    to={getLinkUrl({ url } as LinkUrl)}
    underline={underline}
    variant={variant}
  >
    <Typography
      color={color}
      component="span"
      css={inverted && styles.inverted}
      fontWeight={fontWeight}
    >
      {text}
    </Typography>
  </DefaultLink>
)
